module.exports = __webpack_public_path__ + "img/mastercard-logo.805e608b.svg";